import gql from 'graphql-tag';

export const giftCardPaymentSessionOrderDataQuery = gql`
    query GiftCardPaymentSessionOrderData($paymentSessionId: String!) {
        giftCardPaymentSessionOrderData(paymentSessionId: $paymentSessionId) {
            brandName
            brandLogoUrl
            cardBackgroundColor
            cardTextColor
            giftCards {
                faceAmountInCents
                currency
                quantity
            }
            pointsPerFaceValueMajorCurrencyUnit
            conditionsOfUseUrl
            granularConditionsOfUse {
                multipleUses {
                    description
                    shouldBeCrossedOut
                }
                conjunctionWithOnlineCashback {
                    description
                    shouldBeCrossedOut
                }
                conjunctionWithOtherCashbackGiftCards {
                    description
                    shouldBeCrossedOut
                }
                conjunctionWithOtherNonCashbackGiftCardPaymentMethods {
                    description
                    shouldBeCrossedOut
                }
                validityPeriodText
                activationDelayText
                offlineUsageModalityText
                onlineUsageModalityText
                notRefundableOrExchangeableText
                refundConditionOverrideText
                catchAll {
                    description
                    shouldBeCrossedOut
                }
                shouldHighlightCatchAllConditions
            }
        }
    }
`;

type GranularConditionOfUse = {
    description?: string | null;
    shouldBeCrossedOut?: boolean | null;
};

export type GiftCardGranularConditionsOfUse = {
    multipleUses?: GranularConditionOfUse | null;
    conjunctionWithOnlineCashback?: GranularConditionOfUse | null;
    conjunctionWithOtherCashbackGiftCards?: GranularConditionOfUse | null;
    conjunctionWithOtherNonCashbackGiftCardPaymentMethods?: GranularConditionOfUse | null;
    validityPeriodText?: string | null;
    activationDelayText?: string | null;
    offlineUsageModalityText?: string | null;
    onlineUsageModalityText?: string | null;
    notRefundableOrExchangeableText?: string | null;
    refundConditionOverrideText?: string | null;
    catchAll?: GranularConditionOfUse | null;
    shouldHighlightCatchAllConditions?: boolean | null;
};

type GiftCardPaymentSessionOrderDataItem = {
    faceAmountInCents: number;
    currency: string;
    quantity: number;
};

type GiftCardPaymentSessionOrderData = {
    brandName?: string | null;
    brandLogoUrl?: string | null;
    cardBackgroundColor?: string | null;
    cardTextColor?: string | null;
    giftCards: GiftCardPaymentSessionOrderDataItem[];
    pointsPerFaceValueMajorCurrencyUnit?: number | null;
    conditionsOfUseUrl?: string | null;
    granularConditionsOfUse?: GiftCardGranularConditionsOfUse | null;
};

export type GiftCardPaymentSessionOrderDataQueryResponse = {
    __typename: 'Query';
    giftCardPaymentSessionOrderData: GiftCardPaymentSessionOrderData | null;
};

export type GiftCardPaymentSessionOrderDataQueryVariables = {
    paymentSessionId: string;
};
